import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { navItems } from "../mock";
import { Menu, ArrowRight } from "lucide-react";
import FullscreenMenu from "./FullscreenMenu";
import SegmentedControl from "./SegmentedControl";
import { useModeContext } from "../contexts/ModeContext";
import gsap from "gsap";

const Header = () => {
  const [open, setOpen] = useState(false);
  const { activeMode } = useModeContext();
  const arrowRef = useRef(null);

  // Animate arrow when in Behaviour Change mode
  useEffect(() => {
    if (activeMode === 0 && arrowRef.current) {
      const tl = gsap.timeline({ repeat: -1 });
      tl.to(arrowRef.current, {
        x: 4,
        duration: 0.8,
        ease: "power2.inOut"
      })
      .to(arrowRef.current, {
        x: 0,
        duration: 0.8,
        ease: "power2.inOut"
      });
      
      return () => tl.kill();
    }
  }, [activeMode]);

  return (
    <header className="w-full fixed top-0 left-0 z-50 bg-white/70 dark:bg-neutral-900/70 backdrop-blur supports-[backdrop-filter]:bg-white/60 border-b border-border">
      <div className="mx-auto max-w-7xl px-6 py-3.5 flex items-center justify-between">
        {/* Text-Logo */}
        <Link to="/" className="select-none leading-tight">
          <div className="text-[13px] tracking-[0.12em] uppercase text-neutral-700 dark:text-neutral-300 font-medium">Tom</div>
          <div className="text-[15px] tracking-[0.12em] uppercase text-neutral-900 dark:text-white font-semibold">Oppenhäuser</div>
        </Link>

        {/* Right cluster: unlock text + arrow (BC only) + segmented switch + burger */}
        <div className="flex items-center gap-3">
          {/* Unlock text and arrow - only visible in Behaviour Change mode */}
          {activeMode === 0 && (
            <div className="flex items-center gap-1.5 md:gap-2 text-neutral-700 dark:text-neutral-300 ml-6 md:ml-0">
              <span 
                className="text-xs md:text-sm"
                style={{ fontFamily: "'Caveat', cursive", fontSize: 'clamp(0.73rem, 1.67vw, 0.92rem)' }}
              >
                Unlock your full potential
              </span>
              <ArrowRight 
                ref={arrowRef}
                size={16}
                className="text-neutral-700 dark:text-neutral-300 md:w-[18px] md:h-[18px]"
              />
            </div>
          )}
          
          <div className="block sm:hidden">
            <SegmentedControl compact={true} />
          </div>
          <div className="hidden sm:block">
            <SegmentedControl options={["Behaviour Change","Peak Performance"]} />
          </div>

          <button
            onClick={() => setOpen(true)}
            className="w-11 h-11 inline-flex items-center justify-center rounded-full bg-neutral-900 dark:bg-[#111113] text-white shadow hover:shadow-lg transition"
            aria-label="Menü öffnen"
          >
            <Menu size={20} />
          </button>

          {/* Desktop CTA optional (keine Duplizierung im Overlay) */}
          <div className="hidden">
            <Button className="rounded-full px-5 h-10 text-[15px]">
              {navItems[3].label}
            </Button>
          </div>
        </div>
      </div>

      {/* Fullscreen Overlay Menu (GSAP controlled) */}
      <FullscreenMenu
        isOpen={open}
        onClose={() => setOpen(false)}
        items={navItems.slice(0, 3)}
        cta={navItems[3]}
      />
    </header>
  );
};

export default Header;